import { Injectable } from '@angular/core';
import { CometChat } from '@cometchat/chat-sdk-ionic';
import { NavigationExtras } from '@angular/router';
import { Urls } from 'src/app/pages';
import { timer, Observable } from 'rxjs';
import { UserType } from './chat/entities/UserType';
import { CONSTANTS } from 'src/app/CONSTS';
import { CoreService } from './chat/core-service.service';
import { Session } from './chat/entities/Session';
import { DomSanitizer } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';
import { Location } from '@angular/common';
import { MobileService } from './mobileLogin-api.service';
import { NetworkService } from './networkService.service';
import { mergeMap } from 'rxjs/operators';
import { CometChatCalls } from '@cometchat/calls-sdk-javascript';
import { NgZone } from '@angular/core';
import { registerPlugin } from '@capacitor/core';
const CallingPlugin = registerPlugin<any>('Calling');


@Injectable({
    providedIn: 'root'
})
export class CallingService {
    loggedIn: boolean = false;
    callerStatus;
    receiverStatus;
    time: number = 0;
    numbers: any;
    public userListArray: any = [];
    private inProgressCall?: CometChat.Call;
    private _closing = false;
    private _startedFor?: string;

    constructor(
        public coreService: CoreService,
        public session: Session,
        private _sanitizer: DomSanitizer,
        private location: Location,
        private mobileService: MobileService,
        private networkService: NetworkService,
        private ngZone: NgZone,
    ) {
        this.numbers = timer(0, 1000);
        //this.getUserList(true);
    }

    listenForCalls(listenerID, context) {
        console.log("calling.service.ts  listenForCalls -> listenForCalls() entere");
        try {
            let serviceContext = this;
            CometChat.initiateCall
            CometChat.addCallListener(
                listenerID,
                new CometChat.CallListener({
                    async onOutgoingCallAccepted(call) {
                        console.log("calling.service.ts  listenForCalls -> onOutgoingCallAccepted() entere");
                        console.log('[Calls] onOutgoingCallAccepted');

                        serviceContext.inProgressCall = call;          // 👈 remember it
                        context.callingService.callerStatus = 'Connecting ...';
                        const navigationExtras: NavigationExtras = {
                            state: {
                                initiator: true,
                                call: call
                            }
                        };
                        context.router.navigate([Urls.CallScreen], navigationExtras);
                        // serviceContext.startCallSession(call, context).then(() => {
                        //     context.callingService.callerStatus = 'Ongoing call ...';
                        //     context.callerStatus = 'OngoingCall';
                        // });
                        // const sessionId = call?.sessionId;

                        // // 1) Build the ongoing listener (optional)
                        // const ongoing = new CometChatCalls.OngoingCallListener({
                        //     onUserJoined: (user) => { serviceContext.callerStatus = 'In call';  console.log("calling.service.ts  listenForCalls -> onUserJoined() entere");},
                        //     onUserLeft: (user) => { console.log("calling.service.ts  listenForCalls -> onUserLeft() entere"); },
                        //     onCallEnded: () => {console.log("calling.service.ts  listenForCalls -> onCallEnded() entere");  serviceContext.closeCallUI(context); },
                        //     onCallEndButtonPressed: () => {
                        //        console.log("calling.service.ts  listenForCalls -> onCallEndButtonPressed() entere");
                        //         if (sessionId) {
                        //            console.log("calling.service.ts  listenForCalls -> onCallEndButtonPressed() entere1");
                        //             CometChat.endCall(sessionId).finally(() => serviceContext.closeCallUI(context));
                        //         } else {
                        //            console.log("calling.service.ts  listenForCalls -> onCallEndButtonPressed() entere2");
                        //             serviceContext.closeCallUI(context);
                        //         }
                        //     },
                        //     onError: (err) => { console.error('[Calls] onError', err); serviceContext.closeCallUI(context); },
                        // });

                        // // 2) Build call settings (v4)
                        // const callSettings = new CometChatCalls.CallSettingsBuilder()
                        //     .setMode(CometChatCalls.CALL_MODE.DEFAULT)
                        //     .enableDefaultLayout(true)
                        //     .setIsAudioOnlyCall(call?.type === 'audio')
                        //     .setCallEventListener(ongoing)
                        //     .build();

                        // // 3) Resolve token and start session
                        // try {
                        //     const token = await serviceContext.resolveCallToken(call);
                        //     CometChatCalls.startSession(callSettings, token);
                        // } catch (err) {
                        //     console.error('[Calls] startSession failed:', err?.message || err, err);
                        //     serviceContext.closeCallUI(context);
                        // }
                    },
                    onCallEndedMessageReceived: async (call) => {
                        console.log("calling.service.ts  listenForCalls -> onCallEndedMessageReceived() entere");
                        context.callingService.callerStatus = 'Call ended ...';
                        await CometChat.clearActiveCall();
                        await CometChatCalls.endSession();
                        this._startedFor = undefined;
                        serviceContext.location.back()
                    },
                    onIncomingCallReceived(call) {
                        console.log("calling.service.ts  listenForCalls -> onIncomingCallReceived() entere");
                        //this.customLog("Incoming call customLog:", call);
                        const navigationExtras: NavigationExtras = {
                            state: {
                                initiator: false,
                                call: call
                            }
                        };
                        context.router.navigate([Urls.CallScreen], navigationExtras);
                    },
                    async onOutgoingCallRejected(call) {
                        //this.customLog("Outgoing call rejected customLog : ", call);
                        console.log("calling.service.ts  listenForCalls -> onOutgoingCallRejected() entere");
                        serviceContext.callerStatus = 'Outgoing call rejected'
                        serviceContext.location.back()
                        await CometChat.clearActiveCall();
                        await CometChatCalls.endSession();
                        // Outgoing Call Rejected
                    },
                    async onIncomingCallCancelled(call) {
                        console.log("calling.service.ts  listenForCalls -> onIncomingCallCancelled() entere");
                        serviceContext.receiverStatus = 'Incoming call canceled'
                        //this.customLog("Incoming call canceled customLog:", call);
                        serviceContext.location.back();
                        await CometChat.clearActiveCall();
                        await CometChatCalls.endSession();
                    },
                    onError: error => {
                        console.log("calling.service.ts  listenForCalls -> onError() entere");
                        console.log("calling.service listenForCalls() onError " + error.message, error.message);
                        serviceContext.location.back();
                    }
                })
            );
            // CometChat.addCallListener(
            //     listenerID,
            //     new CometChat.CallListener({
            //         onOutgoingCallAccepted(call) {
            //             //this.customLog('Outgoing call accepted customLog:', call);
            //            console.log("calling.service listenForCalls() onOutgoingCallAccepted ");
            //             context.callingService.callerStatus = 'Connecting ...';
            //             let sessionId = call.sessionId;
            //             let callType = call.type;
            //             const listener = new CometChat.OngoingCallListener({
            //                 onUserJoined: user => {
            //                     /* Notification received here if another user joins the call. */
            //                     //this.customLog('User joined call customLog: ', user);
            //                     serviceContext.callerStatus = 'Call ended ...'
            //                     /* this method can be use to display message or perform any actions if someone joining the call */
            //                 },
            //                 onUserLeft: user => {
            //                     /* Notification received here if another user left the call. */
            //                     serviceContext.callerStatus = 'Call ended ...'
            //                     //this.customLog('User left call customLog:', user);
            //                     /* this method can be use to display message or perform any actions if someone leaving the call */
            //                 },
            //                 onCallEnded: call => {
            //                    console.log("calling.service listenForCalls() onCallEnded ");
            //                     /* Notification received here if current ongoing call is ended. */
            //                     //this.customLog('Call ended customLog: 1', call);
            //                     serviceContext.callerStatus = 'Call ended ...';
            //                     serviceContext.location.back();
            //                     /* hiding/closing the call screen can be done here. */
            //                 },
            //                 onError: error => {
            //                    console.log("calling.service listenForCalls() onError " + error.message, error.message);
            //                     //this.customLog('Error customLog:', error);
            //                     /* hiding/closing the call screen can be done here. */
            //                     serviceContext.location.back();
            //                 }
            //             });
            //             let callSettings = new CometChat.CallSettingsBuilder()
            //                 .setSessionID(sessionId)
            //                 .enableDefaultLayout(true)
            //                 .setIsAudioOnlyCall(callType == 'audio' ? true : false)
            //                 .setCallEventListener(listener)
            //                 .build();
            //             CometChat.startCall(
            //                 callSettings
            //             );
            //         },
            //         onIncomingCallReceived(call) {
            //             //this.customLog("Incoming call customLog:", call);
            //             const navigationExtras: NavigationExtras = {
            //                 state: {
            //                     initiator: false,
            //                     call: call
            //                 }
            //             };
            //            console.log("calling.service listenForCalls() onIncomingCallReceived ");
            //             context.router.navigate([Urls.CallScreen], navigationExtras);
            //         },
            //         onOutgoingCallRejected(call) {
            //            console.log("calling.service listenForCalls() onOutgoingCallRejected ");
            //             //this.customLog("Outgoing call rejected customLog : ", call);
            //             serviceContext.callerStatus = 'Outgoing call rejected'
            //             setTimeout(() => {
            //                 context.router.navigate(['chat-view']);
            //             },
            //                 1000);
            //             // Outgoing Call Rejected
            //         },
            //         onIncomingCallCancelled(call) {
            //            console.log("calling.service listenForCalls() onIncomingCallCancelled ");
            //             serviceContext.receiverStatus = 'Incoming call canceled'
            //             //this.customLog("Incoming call canceled customLog:", call);

            //             setTimeout(() => {
            //                 serviceContext.location.back();
            //             }, 1000);
            //         }
            //     })
            // );
        } catch (error) {
            console.log("calling.service listenForCalls() error " + error.message, error);
            console.error("calling.service listenForCalls() error " + error.message, error);
        }

    }

    getCurrentCall() {
        return CometChat.getActiveCall();
    }

    private callsInitPromise: Promise<void> | null = null;
    public ensureCallsInitOnce(): Promise<void> {
        if (!this.callsInitPromise) {
            const appSettings = new CometChatCalls.CallAppSettingsBuilder()
                .setAppId(environment.APP_ID)
                .setRegion(environment.region)
                .build();
            this.callsInitPromise = CometChatCalls.init(appSettings);
        }
        return this.callsInitPromise;
    }


    public async startCallSession(call: CometChat.Call, contextChat, callElement: HTMLElement = null): Promise<void> {
        //this.registerCallsUIEvents(contextChat);
        const context = this;
        await this.ensureCallsInitOnce();

        const loggedInUser = await CometChat.getLoggedinUser();
        if (!loggedInUser) throw new Error('No logged in user');

        const authToken = (loggedInUser as any).getAuthToken
            ? (loggedInUser as any).getAuthToken()
            : (loggedInUser as any).authToken; // guard for typings

        const sessionId = call.getSessionId?.();
        console.log("calling.service.ts startCallSession -> sesion id is =", sessionId);
        if (!sessionId) throw new Error('No sessionId on call');

        if (this._startedFor === sessionId) return;
        this._startedFor = sessionId;
        // 1) Generate token for this session. :contentReference[oaicite:6]{index=6}
        const tokenRes = await CometChatCalls.generateToken(sessionId, authToken);
        const callToken = tokenRes.token;

        // 2) Prepare Calls UI settings & listeners, then start session. :contentReference[oaicite:7]{index=7}
        const audioOnly = (call as any).type === 'audio';
        const sid = sessionId;
        const listener = new CometChatCalls.OngoingCallListener({
            onUserJoined(user) {
                console.log("calling.service.ts startCallSession -> onUserJoined() entere");
                context.callerStatus = 'Ongoing call ...';
                context.callerStatus = 'OngoingCall';
            },

            onUserLeft() {
                console.log("calling.service.ts startCallSession -> onUserLeft() entere");
            },
            async onCallEndButtonPressed() {
                console.log("calling.service.ts startCallSession -> onCallEndButtonPressed() entere");
                context.callerStatus = 'Call ended ...';
                try {
                    // local user pressed end (in Calls UI)
                    await CometChat.endCall(sessionId).catch(() => { });
                    await CometChatCalls.endSession();
                    await CometChat.clearActiveCall?.();
                    contextChat.location.back();
                } finally {
                    this._startedFor = undefined;
                    contextChat.location.back();
                }
            },
            async onCallEnded() {
                console.log("calling.service.ts startCallSession -> onCallEnded() entere1");
                try {
                    // we are the “other user”
                    await CometChat.clearActiveCall?.();
                    await CometChatCalls.endSession();
                    contextChat.location.back();
                } finally {
                    this._startedFor = undefined;
                    context.location.back();
                }
                // context.location.back();
            },
            async onError(error) {
                console.log("calling.service.ts startCallSession -> onError() entere");
                console.log('Calls error: ', error.message);
                try {
                    await CometChat.clearActiveCall?.();
                    await CometChatCalls.endSession();
                    contextChat.location.back();
                } finally {
                    this._startedFor = undefined;
                    context.location.back();
                }

                //context.location.back();
            },
        });

        try {
            const callSettings = new CometChatCalls.CallSettingsBuilder()
                .enableDefaultLayout(true)
                .setIsAudioOnlyCall(!!audioOnly)
                .setCallListener(listener)
                .build();
            await CometChatCalls.startSession(callToken, callSettings, callElement);
        } catch (error) {
            console.log('CallsService startCallSession error: ', error.message);
        }


    }


    getUserList(isCall: boolean = false) {
        console.log("calling.service.ts  getUserList -> getUserList() entere");
        if (this.session.type === UserType.Contact && !this.session.uid.startsWith(CONSTANTS.CONTACT_PREFIX)) {
            this.session.uid = (CONSTANTS.CONTACT_PREFIX + this.session.uid);
        }

        if (this.session.type === UserType.Patient && !this.session.uid.startsWith(CONSTANTS.PATIENT_PREFIX)) {
            this.session.uid = (CONSTANTS.PATIENT_PREFIX + this.session.uid);
        }

        this.session.uid = this.coreService.replaceCometChatUid(this.session.uid);
        this.session.name = this.coreService.replaceCometChatUid(this.session.name);
        this.coreService.findUser(this.session.uid).subscribe(f => {
            if (f === 404) {
                let calls = this.coreService.createUserApi(this.session.uid, this.session.name)
                calls.pipe(mergeMap(() => this.login2(this.session.uid)));
                if (this.session.type != UserType.Contact && this.session.type != UserType.Patient) {
                    calls = calls.pipe(mergeMap(() => this.coreService.createGroup(this.session.uid)));
                }
                if (this.session.type != UserType.Contact && this.session.type != UserType.Patient && this.session.type != UserType.Admin) {
                    calls = calls.pipe(mergeMap(() => this.coreService.getParticipants(this.session.uid)))
                        .pipe(mergeMap((res) => this.coreService.createUsers(res.filter(x => true))));
                }
                /*else {
                    calls = calls.flatMap(() => {
                        return this.coreService.getAssignedWorker(this.session.id, this.session.businessId);
                    });
                }*/
                calls.subscribe(result => {
                    //this.router.navigate(['main']);
                    this.getParticipants(true);
                });
            }
            if (f === 200) { // user exists
                if (isCall) {
                    const loginm = this.login2(this.session.uid, true);

                    /*if (this.session.type === 4) { // patient
                        loginm = loginm.flatMap(() => {
                            return this.coreService.getAssignedWorker(this.session.id, this.session.businessId);
                        });
                    }*/

                    loginm.subscribe(result => {
                        //if (this.session.type === 4) {
                        //    this.session.workerId = result;
                        //}
                        //this.router.navigate(['main']);

                        this.getParticipants(true);
                    });
                } else {
                    if (f === 200) { // user exists
                        this.getParticipants();
                    }
                }
            }
        });
    }

    unreadMessages: number = 0;
    getUnreadMessageCountForUserList(userListArray: any) {
        return new Promise<any>((resolve, reject) => {
            CometChat.getUnreadMessageCountForAllUsers().then(array => {
                this.unreadMessages = 0;
                const unread = Object.keys(array);
                if (unread.length > 0) {
                    unread.map(uid => {
                        const index = userListArray.findIndex(user => user.uid.toLowerCase() === uid);
                        if (index !== -1) {
                            userListArray[index].unreadCount = array[uid];
                            this.unreadMessages += userListArray[index].unreadCount;
                            resolve(userListArray);
                        }
                    });
                }
            }, error => {
                //this.customLog("Error in getting message count", error);
                reject(error);
            }).catch(e => {
                //this.customLog("Cometchat Error: ");
                //this.customLog(e);
                reject(e);
            });
        });
    }

    private async resolveCallToken(call: any): Promise<string> {
        // 1) Some flows carry the token on the call object
        const direct =
            (call && (call as any).callToken) ||
            (call && (call as any).data && (call as any).data.token);
        if (direct) return direct;

        // 2) Need a sessionId to mint a token
        const sessionId = call?.sessionId;
        if (!sessionId) throw new Error('No call token or sessionId on call object');

        // 3) Get an auth token for the **logged-in** user
        const loggedInUser = await CometChat.getLoggedinUser();
        console.log('resolveCallToken loggedInUser.getName()', loggedInUser.getName());
        const authToken =
            (loggedInUser as any)?.getAuthToken?.()

        console.log('resolveCallToken authToken', authToken);
        if (!authToken) {
            throw new Error('No auth token available. Login with an auth token or provide one from your backend.');
        }
        const { token } = await CometChatCalls.generateToken(sessionId, authToken);
        return token;
    }

    intervalId: any;
    setParticipantsInterval() {
        this.intervalId = setInterval(() => {
            if (this.networkService.userIsOnline2()) {
                this.getParticipants(false, true);
            }
        }, 60000);
    }

    getParticipants(isCall: boolean = false, isFromMainMenu: boolean = false) {
        if (!isFromMainMenu) clearInterval(this.intervalId);
        if ((this.mobileService.hasPermission("Allow Chat") || isCall) && this.networkService.userIsOnline2()) {
            if (this.session) {
                this.coreService.getParticipants(this.session.name).subscribe(results => {
                    if (!isFromMainMenu) {
                        results.map((contact, i) => {
                            results[i] = this.setAvatar(contact);
                            const uid = (results[i].type === UserType.Patient) ? (CONSTANTS.PATIENT_PREFIX + results[i].uid)
                                : (results[i].type === UserType.Contact ? (CONSTANTS.CONTACT_PREFIX + results[i].uid) : results[i].uid);
                            results[i].uid = uid;
                        });
                    }

                    this.userListArray = results;
                    CometChat.getUnreadMessageCountForAllUsers().then(array => {
                        this.unreadMessages = 0;
                        const unread = Object.keys(array);
                        if (unread.length > 0) {
                            unread.map(uid => {
                                const index = this.userListArray.findIndex(user => user.uid.toLowerCase() === uid);
                                if (index !== -1) {
                                    this.userListArray[index].unreadCount = array[uid];
                                    this.unreadMessages += this.userListArray[index].unreadCount;
                                }
                            });
                        }
                    }, error => {
                        //this.customLog("Error in getting message count", error);
                    }).catch(e => {
                        //this.customLog("Cometchat Error: ");
                        //this.customLog(e);
                    });
                });
            }
        }

        if (!isFromMainMenu) this.addUserEventListnerInList();
    }

    addUserEventListnerInList() {

        const listenerID = 'UserEventsListnerInList';

        CometChat.addUserListener(
            listenerID,
            new CometChat.UserListener({
                onUserOnline: onlineUser => {
                    //this.customLog('On User Online:', { onlineUser });
                    for (let i = 0; i < this.userListArray.length; i++) {
                        if (this.userListArray[i].uid === onlineUser.uid) {
                            this.userListArray[i].status = 'Online';
                        }
                    }
                },
                onUserOffline: offlineUser => {
                    //this.customLog('On User Offline:', { offlineUser });
                    for (let i = 0; i < this.userListArray.length; i++) {
                        if (this.userListArray[i].uid === offlineUser.uid) {
                            this.userListArray[i].status = 'Offline';
                        }
                    }
                }
            })
        );
    }

    setAvatar(contact) {
        contact.avatar = this._sanitizer.bypassSecurityTrustResourceUrl(this.coreService.getSVGAvatar(contact.uid, contact.name.substr(0, 1)));
        return contact;
    }

    /**
    * 
    * @param uid login
    * @param type 
    * @param isCall
    */
    login2(uid, isCall: boolean = false): Observable<any> {
        return new Observable<string>(observer => {
            if (this.mobileService.hasPermission("Allow Chat") || isCall) {
                CometChat.login(this.session.uid, environment.API_KEY).then((user) => {
                    //this.customLog("login..." + this.session.uid);
                    observer.next(uid);
                }, error => {
                    observer.next(null);
                });
            }
        });
    }

    debugging: boolean = false;
    // customLog(message?: any, ...optionalParams: any[]){
    //    console.log(message);
    //     if(this.debugging){
    //         if(optionalParams !== undefined && optionalParams != []){
    //            console.log(message, optionalParams);
    //         }else{
    //            console.log(message);
    //         }
    //     }
    // }

    private closeCallUI(context?: any) {
        console.log("calling.service.ts  closeCallUI -> closeCallUI() entere");
        if (this._closing) return;
        this._closing = true;

        this.callerStatus = 'Call ended ...';
        this.receiverStatus = 'Call ended ...';
        try { this.location.back(); } catch { }
    }

    public async endActiveCall(): Promise<void> {
        console.log("calling.service.ts  endActiveCall -> endActiveCall() entere");
        try {
            const sid =
                this.inProgressCall?.getSessionId?.() ??
                CometChat.getActiveCall?.()?.getSessionId?.();

            if (sid) await CometChat.endCall(sid).catch(() => { });
            await CometChatCalls.endSession();
            await CometChat.clearActiveCall?.();
        } finally {
            this._startedFor = undefined;
            this._closing = false;
            this.closeCallUI();
        }
    }

}
